/**
 * EmergencyContacts — static list of TCI emergency numbers with tel: links.
 * Atlas: E5.
 */
"use client";

import { Phone } from "lucide-react";
import { EMERGENCY_CONTACTS } from "@petci/fixtures";
import { useT } from "@/lib/locale";

export function EmergencyContacts() {
  const t = useT();
  return (
    <div className="card-surface space-y-3">
      <h2 className="text-sm font-semibold text-neutral-700">{t("hurricane.emergencyContacts")}</h2>
      <ul className="space-y-2">
        {EMERGENCY_CONTACTS.map((c) => (
          <li key={c.phone} className="flex items-start gap-3">
            <span className="mt-0.5 w-7 h-7 rounded-full bg-semantic-error/10 flex items-center justify-center flex-shrink-0">
              <Phone size={13} className="text-semantic-error" aria-hidden />
            </span>
            <div className="flex-1 min-w-0">
              {/* Contact name stays verbatim (proper noun / official facility name). */}
              <p className="text-sm font-medium text-neutral-800">{c.name}</p>
              {c.detailKey && (
                <p className="text-xs text-neutral-700">{t(c.detailKey)}</p>
              )}
              <a
                href={`tel:${c.phone.replace(/\s/g, "")}`}
                className="text-sm text-brand-primary-text font-semibold hover:underline py-1 -my-1"
              >
                {c.phone}
              </a>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
